import { createFileRoute } from "@tanstack/react-router";
import { ChatWithPanel } from "@/views";

export const Route = createFileRoute("/_dashboard/chat")({
  component: ChatPage,
});

function ChatPage() {
  return <ChatWithPanel />;
}
